import icon from '@assets/img/icons/past-bookings.svg';
import { bookingsStrings } from '@data/bookings';
import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    mainTitle: bookingsStrings.bookingManagement,
    title: bookingsStrings.pastBookings,
  },
});

export const meta: PageMeta = {
  title: strings.title,
  icon,
  order: 3,
  breadcrumbs: [
    {
      to: '/utilities/Bookings/BookingInquiryHistory',
      children: strings.mainTitle,
    },
    {
      children: strings.title,
    },
  ],
};
